import { render, staticRenderFns } from "./JdiMenu.vue?vue&type=template&id=47cbb712&scoped=true&"
import script from "./JdiMenu.vue?vue&type=script&lang=ts&"
export * from "./JdiMenu.vue?vue&type=script&lang=ts&"
import style0 from "./JdiMenu.vue?vue&type=style&index=0&id=47cbb712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbb712",
  null
  
)

export default component.exports